import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorAuthenticated } from '@/stores/auth';
import Header from './header';
import { Wrapper } from './styles';

const MainLayout = () => {
  const isAuthenticated = useSelector(selectorAuthenticated);

  if (!isAuthenticated) {
    const { pathname, search } = window.location;
    return <Navigate to={`/auth/login?redirect=${pathname}${search}`} replace />;
  }

  return (
    <Wrapper>
      <Header />
      <Outlet />
    </Wrapper>
  );
};

export default MainLayout;
